import { render, staticRenderFns } from "./CellRendererMoneda.vue?vue&type=template&id=0b0f3c62&"
import script from "./CellRendererMoneda.vue?vue&type=script&lang=js&"
export * from "./CellRendererMoneda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports